export default __webpack_public_path__ + "static/media/IMG_4983.ee9862f3.png";